import { Component, OnInit, inject } from '@angular/core';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';
import { UserService } from '../user/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {
  private userService = inject(UserService);
  private sessionService = inject(TslSessionService);

  userType = '';

  ngOnInit() {
    if (!this.sessionService.isSignedIn) {
      this.userType = 'guest';
      return;
    }
    this.userService.getProfile().subscribe((user) => {
      if (user.character) {
        this.userType = 'user_intermediate';
      } else {
        this.userType = 'user_beginner';
      }
    });
  }
}
